import React from "react";

const indexIcon = (indexImage, indexProgress) => `./icono${indexImage <= indexProgress + 1 ? indexImage : indexImage + 'gris'}.svg`;

const getImg = ( indexProgress, indexImage) => (
    <img alt="imagen" className="icon-vivirseguro" src={require(`${indexIcon(indexImage,indexProgress)}`).default} /> 
)

export const Img1 = () => (
    <img   className="icon-vivirseguro"
    src={require(`./icono1.svg`).default}
    alt="imagen"
  />
);

export const Img2 =({indexProgress}) => getImg(indexProgress,2);
export const Img3 =({indexProgress}) => getImg(indexProgress,3);
export const Img4 =({indexProgress}) => getImg(indexProgress,4);

export const IconNext = ({ width = 25 }) => (
  <img width={width} src={require(`./arrow-right.png`).default} alt="imagen" />
);

export const IconCheck= ({width = 25}) => ( 
  <img width={width} src={require(`./check.svg`).default} alt="imagen" />
);


export const IconFaceHappy = ({classNameIcon=''}) => ( 
  <img className={classNameIcon} src={require(`./happyface.svg`).default} alt="imagen" />
);

export const IconFaceSad = ({classNameIcon= ''}) => ( 
  <img className={classNameIcon} src={require(`./sadface.svg`).default} alt="imagen" />
);
export const IconVisaMastercard =({ width = 25 }) =>  (
  <img width={width} src={require(`./Groupgg.png`).default} alt="imagen" />
)

